import axios from "axios";
import LinkService from "./services/LinkService";

export default axios.create({
  baseURL: LinkService.geturl() + "/api",

  headers: {
    "Content-type": "application/json",
  }
});